<template>
    <el-dialog
        class="performance-adjustment-attachment-dialog"
        title="上传整改附件"
        :visible.sync="visible"
        width="500px"
        :close-on-click-modal="false"
        :before-close="close"
    >
        <div>
            <el-form class="form-item" ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="上传附件" prop="fileName">
                    <el-input v-model="form.fileName" readonly>
                        <template slot="append"><upload :accept="accept" :fileTypeReg="fileTypeReg" @uploadSuccess="handleUpload"></upload></template>
                    </el-input>
                    <el-button v-if="this.form.fileUrl" type="text" size="mini" class="preview-btn" @click="handlePreview">预览</el-button>
                </el-form-item>
            </el-form>
            <div :style="{ marginLeft: '80px' }">
                <div class="ql-upload-tip">上传文件不超过{{ OSS_FILE_MAX_SIZE }}MB, 文件支持图片,word,.ppt,.pptx,.pdf,.Excel</div>
                <div><el-button type="primary" :loading="tempLoading" @click="handleTemp">下载模板</el-button></div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button class="bigData-btn-submit" :loading="submitLoading" type="primary" @click="submit">提交审批</el-button>
        </span>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </el-dialog>
</template>
<script>
import Upload from '../../../components/upload/Index.vue';
import Preview from '../../../components/viewAttachment.vue';
import { downloadRegisterGuide, submitImprovement } from '../../../api/warehouseResourceManagement/performanceAdjustment.js';
import { OSS_FILE_MAX_SIZE } from '../../../constant/constant.js';

export default {
    components: { Upload, Preview },
    data() {
        return {
            visible: false,
            tempLoading: false,
            submitLoading: false,
            currentRow: {},
            OSS_FILE_MAX_SIZE,
            accept: '.ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx',
            fileTypeReg: /\.(ppt|pptx|pdf|doc|docx|xls|xlsx)$/,
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            form: {
                fileName: '',
                fileUrl: ''
            },
            rules: {
                fileName: [{ required: true, message: '请上传附件', trigger: ['blur', 'change'] }]
            }
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.currentRow = row;
        },
        close() {
            this.currentRow = null;
            this.form = {
                fileName: '',
                fileUrl: ''
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.visible = false;
            });
        },
        submit() {
            this.$refs.form.validate().then(valid => {
                if (valid) {
                    this.submitLoading = true;
                    submitImprovement(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!');
                            this.$emit('success');
                            this.close();
                        }
                    }).finally(() => { this.submitLoading = false; });
                }
            }).catch(err => {});
        },
        getParams() {
            const params = {
                id: this.currentRow.id,
                fileUrl: this.form.fileUrl,
                fileName: this.form.fileName
            };
            return params;
        },
        handleTemp() {
            this.tempLoading = true
            downloadRegisterGuide({ fileName: 'remediationInterviewReportTemplate.xlsx' }).then(res => {
                let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                const blob = new Blob([res], {
                    type: fileType,
                })
                const objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = objectUrl
                a.download = '整改模版.xlsx'
                a.click()
            }).finally(() => { this.tempLoading = false })
        },
        handleUpload(val) {
            if (val.data && +val.data.code === 0) {
                this.form.fileName = val.data.data.localFileName;
                this.form.fileUrl = val.data.data.downUrl;
            }
        },
        handlePreview() {
            this.rowData = {
                downUrl: this.form.fileUrl,
                fileName: this.form.fileName
                // fileId: data.fileId
            };
            this.attachmentShow = true;
        }
    }
};
</script>
<style lang="less">
.performance-adjustment-attachment-dialog {
    .el-input-group {
        margin-right: 10px;
        width: 80%;
    }

    .el-input-group__append {
        padding: 0 10px;
    }

    .ql-upload-tip {
        margin-bottom: 10px;
    }
}
</style>